export const RETIREMENT_EXPENSES_WHAT_IF_KEY = 1;
export const RETIREMENT_EXPENSES_WHAT_IF_PATH = 'WhatIfRetirementExpenses';
